import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

function OtpVerification() {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [timer, setTimer] = useState(60); // 103 seconds = 01:43
  const inputRefs = useRef([]);

  // --- Timer Logic ---
  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const formatTime = () => {
    const mins = Math.floor(timer / 60);
    const secs = timer % 60;
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  // --- OTP Input Logic ---
  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;

    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    // Focus next input
    if (element.value !== "" && index < 3) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index] === "" && index > 0) {
        // Agar current empty hai toh pichle pe jao
        inputRefs.current[index - 1].focus();
      }
    }
  };

  return (
    <div className="scr on" id="s-otp">
      <div className="otp-hero">
        <div className="lg-logo">
          <img
            src="/brandLogo.png"
            style={{ height: "100px", width: "100px", borderRadius: "50%" }}
          />
        </div>
        <h2
          style={{
            fontSize: "1.4rem",
            fontWeight: 800,
            color: "#fff",
            marginBottom: 6,
          }}
        >
          Secure Verification
        </h2>
        <p style={{ fontSize: "0.85rem", color: "rgba(255,255,255,0.8)" }}>
          A 4-digit code has been sent to <br />
          <b style={{ color: "#FFC107" }}>+91 98765 43210</b>
        </p>
      </div>

      <div style={{ padding: "30px 20px 40px" }}>
        <div
          style={{
            textAlign: "center",
            fontSize: "0.85rem",
            color: "var(--muted)",
            fontWeight: 600,
            marginBottom: 15,
            textTransform: "uppercase",
            letterSpacing: "1px",
          }}
        >
          Enter Authorization Code
        </div>

        <div className="otp-grid" style={{ marginBottom: 25 }}>
          {otp.map((data, index) => (
            <input
              key={index}
              type="tel"
              className={`ob ${data ? "f" : ""}`}
              maxLength={1}
              value={data}
              ref={(el) => (inputRefs.current[index] = el)}
              onChange={(e) => handleChange(e.target, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              placeholder="•"
            />
          ))}
        </div>

        <div
          style={{
            textAlign: "center",
            color: "var(--muted)",
            fontSize: "0.85rem",
            marginBottom: 8,
          }}
        >
          Code expires in:{" "}
          <b style={{ color: "var(--or)", fontWeight: "700" }}>
            {formatTime()}
          </b>
        </div>

        <div
          style={{
            textAlign: "center",
            color: "var(--muted)",
            fontSize: "0.82rem",
            marginBottom: 25,
          }}
        >
          Didn't receive the code?{" "}
          <span
            onClick={() => timer === 0 && setTimer(60)} // Resend logic (60s reset)
            style={{
              color: timer === 0 ? "var(--or)" : "#ccc",
              cursor: timer === 0 ? "pointer" : "default",
              fontWeight: "700",
              textDecoration: "underline",
            }}
          >
            Resend OTP
          </span>
        </div>

        <div
          style={{
            background: "rgba(255, 143, 0, 0.05)",
            borderRadius: 13,
            padding: "14px 16px",
            display: "flex",
            gap: 12,
            alignItems: "center",
            marginBottom: 25,
            border: "1px dashed #FFC107",
          }}
        >
          <span style={{ fontSize: "1.2rem" }}>🔒</span>
          <p style={{ fontSize: "0.75rem", color: "#555", fontWeight: 500 }}>
            Your security is our priority. We never share your data with third
            parties.
          </p>
        </div>

        <button
          className="btn btn-or btn-full"
          style={{ fontWeight: "700" }}
          onClick={() => navigate("/profile-setup")}
        >
          Verify & Proceed ✓
        </button>

        <div
          style={{
            textAlign: "center",
            marginTop: 18,
            fontSize: "0.8rem",
            color: "var(--muted)",
          }}
        >
          Entered the wrong number?{" "}
          <b style={{ color: "var(--or)", cursor: "pointer" }}>Edit Number</b>
        </div>
      </div>
    </div>
  );
}

export default OtpVerification;
